import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getProviderDetailsById, updateSelfProvider } from "../fay/Api";
import type { UpdateProviderPayload } from "../fay/Api";

const useProviderDetails = (providerId: string | undefined | null) => {
  const {
    data: providerDetails,
    isLoading: isLoadingDetails,
    isFetched,
    error,
  } = useQuery({
    queryKey: ["provider", providerId],
    queryFn: async () => await getProviderDetailsById(providerId!),
    enabled: !!providerId,
  });

  const queryClient = useQueryClient();

  const { mutateAsync: updateProviderDetails, isPending: isUpdatingProvider } =
    useMutation({
      mutationFn: async ({
        payload,
      }: {
        providerId: string;
        payload: UpdateProviderPayload;
      }) => await updateSelfProvider(payload),
      onSuccess: (response) => {
        queryClient.setQueryData(["provider", providerId], response);
      },
    });

  return {
    providerId: providerDetails?.provider_id,
    providerDetails,
    isLoadingDetails,
    hasFetchedProviderDetails: isFetched,
    updateProviderDetails,
    isUpdatingProvider,
    error,
  };
};

export default useProviderDetails;
